import {MY_PAGE_VIEW_PARAMS} from '../../../home/myPage/common';
import {MyPageSecondTab} from '../../../home/myPage/type';
import {IS_CLIENT} from '../../constant';
import {Page} from '../../constant/page';
import {getThemeOnBody} from '../../function';
import {getClientStore, IReduxState} from '../../store';
import {INoticeType} from '../../type';
import {assert} from '../assert';
import {
  getCurrentClientPage,
  getQueryValue,
  getRouterQueryObject,
} from '../PageRouter';
import {ISendPageViewParam} from '../tracking';

// 라우팅시 자동으로 수집 가능한 페이지 정보를 추가한다. 불가능하면 직접 sendPageView를 호출해야한다.
const PAGE_VIEW_PARAMS: {
  [page in Page]?: (state: IReduxState) => ISendPageViewParam;
} = {
  [Page.Special]: () => ({
    section: 'main',
    page: 'main_special_bridge',
    actionName: 'special_bridge',
  }),
  [Page.Event]: () => ({
    section: 'event_page',
    page: 'event_page',
    actionName: 'event_page',
  }),
  [Page.ContentPurchase]: () => {
    const contentId = getRouterQueryObject().id;
    return {
      section: 'ticketpurchase',
      page: 'ticketpurchase',
      actionName: 'ticketpurchase',
      customProps: {content_id: contentId},
    };
  },
  [Page.More]: () => ({
    section: 'sidemenu',
    page: 'sidemenu',
    actionName: 'sidemenu',
    isSendExtra: true,
  }),
  [Page.MoreMyNews]: () => ({
    section: 'sidemenu',
    page: 'sidemenu_news',
    actionName: 'news',
    isSendExtra: true,
  }),
  [Page.MoreNotice]: () => ({
    section: 'sidemenu',
    page: 'sidemenu_notice',
    actionName: 'notice',
    isSendExtra: true,
  }),
  [Page.MoreMyInformation]: () => ({
    section: 'setting',
    page: 'setting_account',
    actionName: 'account',
    isSendExtra: true,
  }),
  [Page.MoreMyInformationChangeNickname]: () => ({
    section: 'sidemenu',
    page: 'sidemenu_change_nickname',
    actionName: 'change_nickname',
    isSendExtra: true,
  }),
  [Page.MoreMyInformationServiceWithdrawal]: () => ({
    section: 'setting',
    page: 'setting_delete_account',
    actionName: 'delete_account',
    isSendExtra: true,
  }),
  [Page.MoreCouponRegister]: () => ({
    section: 'sidemenu',
    page: 'sidemenu_coupon',
    actionName: 'coupon',
    isSendExtra: true,
  }),
  [Page.MoreCustomerCenter]: () => ({
    section: 'sidemenu',
    page: 'sidemenu_customer_center',
    actionName: 'customer_center',
    isSendExtra: true,
  }),
  [Page.MoreFaq]: () => ({
    section: 'setting',
    page: 'setting_help_faq',
    actionName: 'help_faq',
    isSendExtra: true,
  }),
  [Page.WebviewNotice]: () => {
    const type = getQueryValue('type') as INoticeType;

    let section = 'sidemenu';
    let page = 'sidemenu_notice';
    let actionName = 'notice';
    let customProps;

    if (type === 'faq') {
      section = 'setting';
      page = 'setting_help_faq';
      actionName = 'help_faq';
    } else if (type === 'content') {
      section = 'content_home';
      page = 'content_notice';
      actionName = 'content_notice';
      customProps = {content_id: getRouterQueryObject().id};
    }

    return {
      section,
      page,
      actionName,
      customProps,
      isSendExtra: true,
    };
  },
  [Page.MoreInquiry]: () => ({
    section: 'setting',
    page: 'setting_customer_contact_us',
    actionName: 'customer_contact_us',
    isSendExtra: true,
  }),
  [Page.MoreRightReport]: () => ({
    section: 'setting',
    page: 'setting_customer_rights_report',
    actionName: 'customer_rights_report',
    isSendExtra: true,
  }),
  [Page.MoreServiceInformation]: () => ({
    section: 'setting',
    page: 'setting_serviceinfo',
    actionName: 'serviceinfo',
    isSendExtra: true,
  }),
  [Page.MoreBusiness]: () => ({
    section: 'setting',
    page: 'setting_serviceinfo_businessinfo',
    actionName: 'serviceinfo_businessinfo',
    isSendExtra: true,
  }),
  [Page.MoreSetting]: () => ({
    section: 'setting',
    page: 'setting',
    actionName: 'setting',
    isSendExtra: true,
  }),
  [Page.AuthTerms]: () => ({
    section: 'terms_agreement',
    page: 'terms_agreement',
    actionName: 'terms_agreement',
    isSendExtra: true,
  }),
  [Page.MyPageEpisodeList]: () => ({
    section: 'library',
    page: 'library_purchased_episode_list',
    actionName: 'purchased_episode_list',
    customProps: {content_id: getRouterQueryObject().content_id},
    isSendExtra: true,
  }),
  [Page.AuthIntegration]: () => ({
    section: 'account_integration_guide',
    page: 'account_integration_guide',
    actionName: 'account_integration_guide',
    isSendExtra: true,
  }),
  [Page.AddedCashReceipt]: () => ({
    section: 'cashpurchase',
    page: 'cashpurchase_history',
    actionName: 'cash_receipt',
  }),
  [Page.MorePolicy]: () => ({
    section: 'setting',
    page: 'setting_serviceinfo_policy',
    actionName: 'serviceinfo_policy',
    isSendExtra: true,
  }),
  [Page.MorePolicyTerms]: () => ({
    section: 'setting',
    page: 'setting_serviceinfo_terms',
    actionName: 'serviceinfo_terms',
    isSendExtra: true,
  }),
  [Page.ContentNotice]: () => ({
    section: 'content_home',
    page: 'content_notice',
    actionName: 'content_notice',
    customProps: {content_id: getRouterQueryObject().id},
    isSendExtra: true,
  }),
  [Page.MoreSettingThirdParty]: () => ({
    section: 'setting',
    page: 'setting',
    actionName: 'privacy_provide',
    isSendExtra: true,
  }),
  [Page.Gift]: () => {
    const tab = getRouterQueryObject().tab?.toString() || 'events';
    return {
      section: 'giftbox',
      page: `giftbox_${tab === 'events' ? 'event' : 'ticket'}`,
      actionName: tab === 'events' ? 'event' : 'ticket',
      customProps: {display_theme: getThemeOnBody()},
      isSendExtra: true,
    };
  },
  [Page.MoreCashHistory]: () => {
    const tab = getRouterQueryObject().tab?.toString() || 'added';
    const logName =
      tab === 'added' ? 'cashpurchase_history' : 'cashpurchase_history_used';

    return {
      section: 'cashpurchase',
      page: logName,
      actionName: logName,
      isSendExtra: true,
    };
  },
  [Page.MoreTicketHistory]: () => {
    const tab = getRouterQueryObject().tab?.toString() || 'added';
    const isAddedTab = tab === 'added';

    return {
      section: 'sidemenu',
      page: isAddedTab
        ? 'sidemenu_ticketpurchase_history'
        : 'sidemenu_ticketuse_history',
      actionName: isAddedTab ? 'ticketpurchase_history' : 'ticketuse_history',
      isSendExtra: true,
    };
  },
  [Page.MoreDaumCashHistory]: () => {
    const tab = getRouterQueryObject().tab?.toString() || 'added';
    const logName =
      tab === 'added'
        ? 'daumwebtoon_cash_history'
        : 'daumwebtoon_purchase_history';

    return {
      section: 'daumwebtoon',
      page: logName,
      actionName: 'cash_history',
      isSendExtra: true,
    };
  },
  [Page.MyPageItemList]: () => {
    const tab = (getRouterQueryObject().tab || 'recent') as MyPageSecondTab;

    return {
      section: 'library',
      page: `${MY_PAGE_VIEW_PARAMS[tab].page}_edit`,
      actionName: `${MY_PAGE_VIEW_PARAMS[tab].actionNameAndSort}_edit`,
      customProps: {display_theme: getThemeOnBody()},
      isSendExtra: true,
    };
  },
  [Page.ContentTicketHistory]: () => {
    const tab = getRouterQueryObject().tab?.toString() || 'added';
    const isAddedTab = tab === 'added';
    const contentId = getRouterQueryObject().id;

    return {
      section: 'content_home',
      page: isAddedTab
        ? 'content_ticketpurchase_history'
        : 'content_ticketuse_history',
      actionName: isAddedTab ? 'ticketpurchase_history' : 'ticketuse_history',
      customProps: {
        content_id: contentId,
      },
      isSendExtra: true,
    };
  },
};

export function getPageViewParams(): ISendPageViewParam | undefined {
  assert(IS_CLIENT, '클라이언트에서 실행되어야합니다.');

  const page = getCurrentClientPage();
  const state = getClientStore()?.getState();

  if (state) {
    return PAGE_VIEW_PARAMS[page]?.(state);
  }
}
